import { useSupplierSessionStore } from '@supplier/stores/useSupplierSessionStore'
import Cookies from 'js-cookie'

import { userpilot } from '@/services/userpilot'

export function installNavigationGuards(router) {
  router.beforeEach(async() => {
    const session = useSupplierSessionStore()
    if (session.isSupplier) return true
    if (!Cookies.get('token')) {
      session.redirectToLogin()
      return false
    }
    await session.ensureUser()
    if (session.isSupplier) return true
    if (session.loadState !== 'error') session.redirectToLogin()
    return false
  })

  router.afterEach((_to, _from, failure) => {
    if (!failure) userpilot.reload()
  })
}
